import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { PageHeader } from "../../components/UI";
import { useLanguage } from "../../contexts/LanguageContext";
import Overview from "./Overview";
import Users from "./Users";
import Maps from "./Maps";
import Moderation from "./Moderation";
import SupportQueue from "./Support";
import { Surface, Unavailable } from "./ui";

/** Разделы без серверного API: честное состояние вместо демонстрационных чисел и фиктивных кнопок. */
function NotConnected({ section }: { section: "subscriptions" | "finance" | "analytics" | "settings" }) {
  const { t } = useLanguage();
  return (
    <>
      <PageHeader title={t(`adm.${section}`)} />
      <Surface>
        <Unavailable>
          <h2>{t("adm.na_title")}</h2>
          <p>{t(`adm.na_${section}`)}</p>
          <p>{t("adm.na_text")}</p>
        </Unavailable>
      </Surface>
    </>
  );
}

export const ADMIN_SECTIONS = ["overview", "users", "maps", "subscriptions", "finance", "moderation", "analytics", "settings", "support"] as const;

/** Раздел определяется URL: /admin/<section>. Старый адрес /admin ведёт в обзор. */
export default function Admin() {
  const { "*": rest } = useParams();
  const section = (rest || "").split("/")[0];
  if (!section) return <Navigate to="/admin/overview" replace />;
  switch (section) {
    case "overview":
      return <Overview />;
    case "users":
      return <Users />;
    case "maps":
      return <Maps />;
    case "moderation":
      return <Moderation />;
    case "support":
      return <SupportQueue />;
    case "subscriptions":
    case "finance":
    case "analytics":
    case "settings":
      return <NotConnected section={section} />;
    default:
      return <Navigate to="/admin/overview" replace />;
  }
}
